module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA2UExURf///////////////////////////0dwTP////////////////////////////////////////G+BLQAAAASdFJOU5k5X3OPClYAE4ZgfENMTX0wJta2MekAAAC7SURBVDjLjZPtGsMQDIUPE1LWdrv/mx1dP4ii5xfyPiGSA3eKlF8NYFav6DrFsWAbg6c8C4AshJYC4AmVJr6Au/hBoBnfiQQ04pGgDVjQlE0AoyOOgO4B1oGy7YdfAjAEVSR0b1MSCroEnEjiEQQgkgSYCiiSGFHULtuself+sOEVw0cOyxx+FGUn3+qrYyeaJf1veNLuXop5myhqj9zToR2O/dg4UXM1jSTNW3TQcuXuZH8dkv2Dzu3/AzxeCbJXe+mSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/play-btn.png
// module id = I8gx
// module chunks = 18